<template>
  <div
    v-if="!closed"
    class="wrapper"
  >
    <div class="popup">
      <p>{{ $t('layout.passwordResetReminder.text') }} <a href="/ustawienia">{{ $t('layout.passwordResetReminder.linkText') }}</a>.</p>
      <FormButton
        :type="'button'"
        :label="$t('layout.passwordResetReminder.close')"
        @click="close"
        :disabled="false"
      />
    </div>
  </div>
</template>

<style scoped>
  .wrapper {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.75);
    z-index: 1000;
  }

  .popup {
    max-width: 475px;
    padding: 40px;
    line-height: 2;
    background-color: var(--secondary-background-color);
    border-radius: 3px;
  }
</style>

<script>
  import FormButton from '../form/FormButton.vue';

  export default {
    components: {
      FormButton
    },
    data() {
      return {
        closed: false
      };
    },
    methods: {
      close() {
        this.closed = true;
      }
    }
  }
</script>
